import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { articles, categories } from "@/mocks/news";

export default function CategoryStrip() {
  return (
    <section id="channels" className="mx-auto max-w-content scroll-mt-32 px-4 pt-16 md:px-6 md:pt-20">
      <SectionHeading
        eyebrow="Channels"
        title="四个频道，覆盖娱乐圈最容易上头的现场"
        description="每个频道都有自己的观察角度：塌房看时间线，绯闻看证据链，翻车看现场技术，综艺看剪辑逻辑。"
      />
      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((category) => {
          const count = articles.filter((item) => item.categorySlug === category.slug).length;
          return (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              title={`${category.name}频道 - 美日吃瓜`}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="h-36 w-full overflow-hidden bg-background-200">
                <img
                  src={category.cover}
                  alt={`${category.name}频道配图`}
                  title={`${category.name} - 美日吃瓜`}
                  className="h-full w-full object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-4">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-base font-bold text-foreground-900 transition-colors group-hover:text-primary-700">
                    {category.name}
                  </h3>
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-800">
                    {count} 篇
                  </span>
                </div>
                <p className="mt-1 text-xs font-medium text-accent-700">{category.short}</p>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-600">
                  {category.description}
                </p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                  进入频道
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}